import React from 'react'
import { Link, useParams } from 'react-router-dom'
import CollapsingHeader from '../Components/CollapsingHeader'
import SortedFeed, { NotFoundMessage, useSortParam } from '../Components/SortedFeed'
import { useDocumentTitle } from '../Hooks/useDocumentTitle'
import { useFeed } from '../Hooks/useFeed'
import { t } from '../i18n'
import { api } from '../Services/api'
import { useFollow } from '../State/Follow'
import { useResource } from '../State/refData'
import { track } from '../Utils/analytics'

/* /kategorija/{slug} (spec 5.6), opened from Istraži and search: up to 5
   current topics of the category, then tabs and its feed. Categories aren't
   followed, so there's no "+ Prati". */
export default function CategoryPage() {
  const { slug } = useParams()
  const [sort, setSort] = useSortParam()
  const { sources: followed } = useFollow()
  const feed = useFeed(`category:${slug}:${sort}:${followed.join(',')}`, ({ cursor, refresh }) =>
    api.categoryStories(slug, { sort, cursor, followed, refresh })
  )
  const info = useResource(`category:${slug}`, () => api.category(slug))
  const category = info.data || feed.extra.category
  useDocumentTitle(category?.title || null)
  const missing = feed.status === 'error' && feed.error?.response?.status === 404
  const topics = info.data?.topics || []

  return (
    <>
      <CollapsingHeader title={category?.title || ''}>
        {topics.length > 0 && (
          <section className="category-topics">
            <h2 className="section-title">{t('category.topics')}</h2>
            <div className="chip-wrap">
              {topics.map((topic, i) => (
                <Link
                  key={topic.slug}
                  to={`/tema/${topic.slug}`}
                  className="chip"
                  onClick={() => track('topic_open', { from: 'category_page', topic: topic.slug })}
                >
                  {i < 2 && <span className="topic-dot" aria-hidden="true" />}
                  <span>{topic.shortTitle || topic.title}</span>
                </Link>
              ))}
            </div>
          </section>
        )}
      </CollapsingHeader>
      {missing ? (
        <NotFoundMessage />
      ) : (
        <SortedFeed feed={feed} sort={sort} setSort={setSort} from="category" />
      )}
    </>
  )
}
